import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const Spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled("div")`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  animation: ${Spin} 1.5s linear infinite;
`;

export const GlobalLoadingOverlay = styled("div")`
  position: fixed;
  inset: 0;
  z-index: 9999;
`;
